import { render, staticRenderFns } from "./ChannelDetail.vue?vue&type=template&id=50273fce&scoped=true&"
import script from "./ChannelDetail.vue?vue&type=script&lang=ts&"
export * from "./ChannelDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelDetail.vue?vue&type=style&index=0&id=50273fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50273fce",
  null
  
)

export default component.exports